<template>
  <UmyBasicList
    :showIndexCol="false"
    :show-select-col="true"
    :show-action-col="false"
    :showPage="false"
    :table-h="tableH"
    :fields="fields"
    :loading="state.loading"
    :total="state.total"
    :list="state.list"
    select-type="singleMult"
    :tree-config="treeConfig"
    :selection-change="selectionChange"
    class-name="menuResource"
    highlight-current
    row-key="id"
    :show-extend-set="buttonData('cdkzan').has"
    :extDlgVis="queryExtendList"
    :extend-list="extendList"
    :extend-fields="extendFields"
    :handle-save-extend-set="handleSaveExtendSet"
  >
    <template slot="hd-col--l">
      <el-button
        type="primary"
        size="mini"
        :clstag="clstag('menuResource_1619350982488|1')"
        @click="onSonMenu"
        v-if="buttonData('tjzcd').has"
        >{{ buttonData("tjzcd").name }}</el-button
      >
      <!-- 导入 -->
      <el-button
        type="primary"
        size="mini"
        :clstag="clstag('menuResource_1619350982488|2')"
        @click="importData"
        v-if="buttonData('CDDR').has && this.showExportButton"
        >{{ buttonData("CDDR").name }}</el-button
      >
      <!-- 导出 -->
      <el-button
        type="primary"
        size="mini"
        :clstag="clstag('menuResource_1619350982488|3')"
        @click="exportMenuData"
        v-if="buttonData('DCCDZY').has && this.showExportButton"
        >{{ buttonData("DCCDZY").name }}</el-button
      >
      <!-- 编辑 -->
      <el-button
        size="mini"
        :clstag="clstag('menuResource_1619350982488|4')"
        @click="onEdit"
        v-if="buttonData('bjcdzy').has"
        >{{ buttonData("bjcdzy").name }}</el-button
      >
      <!-- biangengfujiedian -->
      <el-button
        size="mini"
        :clstag="clstag('menuResource_1619350982488|5')"
        @click="onChangeParent"
        v-if="buttonData('BGZYFJG').has"
        >{{ buttonData("BGZYFJG").name }}</el-button
      >
      <!-- 删除 -->
      <el-button
        type="danger"
        size="mini"
        :clstag="clstag('menuResource_1619350982488|6')"
        @click="onDelete"
        v-if="buttonData('sccdzy').has"
        >{{ buttonData("sccdzy").name }}</el-button
      >
      <!-- 启用 -->
      <el-button
        v-if="buttonData('cdqy').has && isDisable"
        size="mini"
        :clstag="clstag('menuResource_1619350982488|7')"
        @click="handleEnableOrDisable"
        >{{ buttonData("cdqy").name }}</el-button
      >
      <!-- 停用 -->
      <el-button
        v-if="buttonData('cdty').has && isEnable"
        :clstag="clstag('menuResource_1619350982488|8')"
        size="mini"
        @click="handleEnableOrDisable"
        >{{ buttonData("cdty").name }}</el-button
      >
      <!-- 上移 -->
      <el-button
        v-if="isCanUp"
        :clstag="clstag('menuResource_1619350982488|9')"
        size="mini"
        @click="handleUp"
        >{{$t('language.5o6v4bole4o0')}}</el-button
      >
      <!-- 下移 -->
      <el-button
        v-if="isCanDown"
        size="mini"
        :clstag="clstag('menuResource_1619350982488|10')"
        @click="handleDown"
        >{{$t('language.5o6v4bolesg0')}}</el-button
      >
      <!-- 关联菜单角色 -->
      <el-button
        v-if="buttonData('GLCDJS').has && selRows.length !== 0"
        size="mini"
        @click="handleConnectMenuRole(selRows[0])"
        >{{ buttonData("GLCDJS").name }}</el-button
      >
    </template>
  </UmyBasicList>
</template>

<script>
import { mapState } from "vuex";
import ExactList from "@/mixins/exactList";
import { clstagData } from "@/utils/req";
export default {
  mixins: [ExactList],
  props: {
    addSonMenu: Function,
    exchange: Function,
    queryObj: Object,
    queryList: Function,
    onSonMenuRole: Function,
    onSonMenuRoled: Function,
    importData: Function,
    exportMenuData: Function,
    changeParent: Function,
    handleConnectMenuRole: Function,
  },
  data() {
    const self = this;
    return {
      maps: new Map(),
      treeConfig: {
        expandRowKeys: self.$store.state.menuResource.expandKey,
      },
      fields: [
        { key: "resourceName", name: this.$t('language.5o6upp1vp000'), align: "left", width: 300 },
        // { key: "resourceSeq", name: "菜单序号", width: 100 },
        { key: "resourceCode", name: this.$t('language.5o6upp1vp2w0') },
        {
          key: "resourceType",
          name: this.$t('language.5o6otz4p1n40'),
          render: (h, { index, row, col }) => {
            if (row.resourceType === 0) {
              return (
                <span class="cell-menu-word-style cell-common-word">
                  {CNST.ENUMS.resourceType[row.resourceType]}
                </span>
              );
            } else if (row.resourceType == 1) {
              return (
                <span class="cell-button-word-style cell-common-word">
                  {CNST.ENUMS.resourceType[row.resourceType]}
                </span>
              );
            } else {
              return (
                <span class="cell-others-word-style cell-common-word">
                  {CNST.ENUMS.resourceType[row.resourceType]}
                </span>
              );
            }
          },
        },
        {
          key: "sensitiveMark",
          name: this.$t('language.5o6v4bolf5k0'),
          width: 200,
          render: (h, { row }) => {
            const status = { 0: this.$t('language.5o6uj7uyta00'), 1: this.$t('language.5o6uj7uytcs0') };
            const value = status[row.sensitiveMark];
            return <span>{value}</span>;
          },
        },
        { key: "resourceUrl", name: "URL" },
        {
          key: "isDisable",
          name: this.$t('language.5o6u3frcncs0'),
          render: (h, { row }) => {
            const status = { 0: this.$t('language.5o6trh9vmow0'), 1: this.$t('language.5o6trh9vmrs0') };
            const value = status[row.isDisable];
            return <span>{value}</span>;
          },
        },
        { key: "createTime", name: this.$t('language.5o6otz4p1t00'), width: 180 },
        { key: "remark", name: this.$t('language.5o6otz4p1w00') },
      ],
      extendFields: [
        { key: "extNo", name: this.$t('language.5o6v4bolfsc0'), width: 80 },
        {
          key: "isEffective",
          name: this.$t('language.5o6v4bolfv40'),
          width: 80,
          render: (h, { row }) => (
            <el-checkbox
              v-model={row.isEffective}
              true-label={1}
              false-label={0}
            />
          ),
        },
        {
          key: "isRequired",
          name: this.$t('language.5o6v4bolfxo0'),
          width: 80,
          render: (h, { row }) => (
            <el-checkbox
              v-model={row.isRequired}
              true-label={1}
              false-label={0}
            />
          ),
        },
        {
          key: "extName",
          name: this.$t('language.5o6v4bolg0c0'),
          render: (h, { row }) => {
            return <el-input v-model_trim={row.extName} size="small" />;
          },
        },
        {
          key: "isEnum",
          name: this.$t('language.5o6v4bolg340'),
          width: 120,
          render: (h, { row }) => (
            <el-checkbox v-model={row.isEnum} true-label={1} false-label={0} />
          ),
        },
        {
          key: "enumValue",
          name: this.$t('language.5o6v4bolg5s0'),
          render: (h, { row }) => (
            <el-input
              v-model_trim={row.enumValue}
              placeholder={this.$t('language.5o6vkto5z640')}
              size="small"
            />
          ),
        },
      ],
    };
  },
  created() {
    this.queryExtendList(true);
  },
  methods: {
    clstag(data) {
      clstagData(data);
    },
    // load子节点
    loadChilden(row, treeNode, resolve) {
      const id = row.id;
      this.maps.set(id, {
        row,
        treeNode,
        resolve,
      });
      this.$parent
        .dispatch("load", {
          parentId: id,
        })
        .then((arr) => {
          console.log(arr, "menu de ");
          if (arr && arr.length) {
            row.children = arr;
            resolve(arr);
          } else {
            row.hasChild = false;
            resolve([]);
          }
        });
    },
    async handleUp() {
      const params = {
        data: {
          tenementCode: this.selRows[0].tenementCode,
          moveFlag: 1,
          appId: this.selRows[0].appId,
          id: this.selRows[0].id,
        },
      };
      const { code, msg } = await api.menuResource.moveMenu(params);
      if (code === 200) {
        this.$message.success(msg);
        this.$emit("UPDATE_LIST");

        const { pid } = this.selRows[0].parentId; //取出当前删除行的pid

        console.log(this.selRows[0].parentId, this.maps, this.maps.get(11271));
        const { row, treeNode, resolve } = this.maps.get(11271); //根据pid取出对应的节点数据
        // this.$set(this.state.lazyTreeNodeMap, pid, []); //将对应节点下的数据清空，从而实现数据的重新加载
        this.loadChilden(row, treeNode, resolve);
      } else {
        this.$message.error(msg);
      }
    },
    async handleDown() {
      const params = {
        data: {
          tenementCode: this.selRows[0].tenementCode,
          moveFlag: 0,
          appId: this.selRows[0].appId,
          id: this.selRows[0].id,
        },
      };
      const { code, msg } = await api.menuResource.moveMenu(params);
      if (code === 200) {
        this.$message.success(msg);
        this.$emit("UPDATE_LIST");
      } else {
        this.$message.error(msg);
      }
    },
    onDelete() {
      const rows = this.selRows;
      if (!rows.length) {
        this.$message.error(this.$t('language.5o6v4bolg8s0'));
        return false;
      }
      if (rows.length > 1) {
        this.$message.error(this.$t('language.5o6v4bolgcc0'));
        return false;
      }
      if (rows[0].parentId == null) {
        this.$message.error(this.$t('language.5o6v4bolggs0'));
        return false;
      }
      this.handleDelete(rows[0]); //
    },
    onEdit() {
      const rows = this.selRows;
      if (!rows.length) {
        this.$message.error(this.$t('language.5o6v4bolgjc0'));
        return;
      }
      if (rows.length > 1) {
        this.$message.error(this.$t('language.5o6v4bolglk0'));
        return;
      }
      if (rows[0].parentId == null) {
        this.$message.error(this.$t('language.5o6v4bolgnk0'));
        return false;
      }
      this.handleEdit({ id: rows[0].id }, true);
    },
    onChangeParent() {
      const rows = this.selRows;
      if (!rows.length) {
        this.$message.error(this.$t('language.5o6v4bolgpk0'));
        return;
      }
      if (rows.length > 1) {
        this.$message.error(this.$t('language.5o6v4bolgrk0'));
        return;
      }
      if (rows[0].parentId == null) {
        this.$message.error(this.$t('language.5o6v4bolgtk0'));
        return false;
      }
      this.changeParent({ row: rows }, true);
    },
    //添加子菜单
    onSonMenu() {
      const rows = this.selRows;
      if (!rows.length) {
        this.$message.error(this.$t('language.5o6v4bolgvg0'));
        return;
      }
      if (rows.length > 1) {
        this.$message.error(this.$t('language.5o6v4bolgxk0'));
        return;
      }
      this.addSonMenu(rows[0]);
    },
    // 禁用/启用菜单角色
    handleEnableOrDisable() {
      if (this.selRows.length === 0) return;
      // 0表示启用状态 1表示禁用状态
      const { isDisable, tenementCode, id } = this.selRows[0];
      const params = { data: { tenementCode, id } };
      if (isDisable === 0) {
        this.$confirm(this.$t('language.5o6v4bolg5w0'), this.$t('language.5o6v4bolgz10'), {
          confirmButtonText: this.$t('language.5o6uyb93vi10'),
          cancelButtonText: this.$t('language.5o6u3frcn8k0'),
          type: "warning",
        }).then(() => {
          this.handleDisableResourceRole(params);
        });
      } else if (isDisable === 1) {
        this.handleEnableResourceRole(params);
      }
    },
    // 禁用
    async handleDisableResourceRole(params) {
      const { code, msg } = await api.menuResource.disableResource(params);
      if (code === 200) {
        this.$message.success(msg);
        this.$emit("UPDATE_LIST");
      } else {
        this.$message.error(msg);
      }
    },
    // 启用
    async handleEnableResourceRole(params) {
      const { code, msg } = await api.menuResource.enableResource(params);
      if (code === 200) {
        this.$message.success(msg);
        this.$emit("UPDATE_LIST");
      } else {
        this.$message.error(msg);
      }
    },
    // 扩展字段保存
    async handleSaveExtendSet({ done } = {}) {
      const flag = this.checkExtendFieldParams();
      if (flag) {
        const params = { data: _.cloneDeep(this.extendList) };
        const query = { appCode: this.state.query.appCode };
        const { code, msg } = await api.menuResource.extendFieldSet(
          params,
          query
        );
        if (code === 200) {
          this.$message.success(msg);
          this.setListExtendFields(this.extendList, undefined, true);
          done && done();
        } else {
          this.$message.error(msg);
        }
      }
    },
    // 请求扩展字段
    async queryExtendList(flag) {
      this.extendList = this.getDefaultExtendList(10);
      const params = {
        data: {
          tenementCode: this.tenementCode,
          appCode: this.state.query.appCode,
        },
      };
      const { code, msg, data } = await api.menuResource.queryExtendField(
        params
      );
      if (code === 200) {
        this.extendToFront(data || []);
        if (flag) {
          this.setListExtendFields(this.extendList, undefined, true);
        }
      } else {
        this.$message.error(msg);
      }
    },
  },
  computed: {
    ...mapState("app", ["tenementInfoObj"]),
    isEnable() {
      return this.selRows.length !== 0 && this.selRows[0].isDisable === 0
        ? true
        : false;
    },
    isDisable() {
      return this.selRows.length !== 0 && this.selRows[0].isDisable === 1
        ? true
        : false;
    },
    isCanUp() {
      return this.selRows.length !== 0 && this.selRows[0].resourceSeq !== 1
        ? true
        : false;
    },
    isCanDown() {
      return this.selRows.length !== 0 && this.selRows[0].isLevelLast !== true
        ? true
        : false;
    },
  },
  watch: {
    tenementInfoObj: {
      deep: true,
      immediate: false,
      handler: function (newVal) {
        if (newVal.tenementCode) {
          this.queryList();
        }
      },
    },
  },
};
</script>

<style lang="scss">
.el-table__header-wrapper {
  /deep/ .el-table__header {
    .is-left {
      text-align: center;
    }
  }
}
</style>
